import { render } from "./RegisterPage.vue?vue&type=template&id=3220062e&scoped=true"
import script from "./RegisterPage.vue?vue&type=script&lang=js"
export * from "./RegisterPage.vue?vue&type=script&lang=js"

import "./RegisterPage.vue?vue&type=style&index=0&id=3220062e&scoped=true&lang=css"

import exportComponent from "E:\\project\\exam\\web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3220062e"]])

export default __exports__